import './IncidentItemDetailsContextMenuPart.scss'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover'
import IEntityIncident from '../../interfaces/entityIncident/IEntityIncident'
import ICustomer from '../../interfaces/customer/ICustomer'
import IIncidentHistory from '../../interfaces/entityIncident/IIncidentHistory'
import ToLocaleStringFixed from '../../functions/dateTime/ConvertToFormat'
import { currentLanguageFormatCode } from "../../../configuration"
import React, { useEffect, useState } from 'react'
import IAction from '../../interfaces/actions/action'
import GetActions from '../../services/action/ActionService'
import { useMsal } from '@azure/msal-react'

type ComponentProps = {
  customer: ICustomer
  entityIncident: IEntityIncident
}


const IncidentItemDetailsContextMenuPart = (props:ComponentProps) => {

  const {instance} = useMsal()
  const [actions, setActions] = useState<IAction[]>([])

  useEffect(() => {
    GetActions(instance, props.customer.customerID, props.entityIncident.entity.sensorID, props.entityIncident.entity.spotID, props.entityIncident.entity.entityType, props.entityIncident.entity.entityID, props.entityIncident.entity.entityLocalID).then(actionResult => setActions(actionResult))
  }, [])

  const renderContextMenu:any = (entityIncident:IEntityIncident) => (
    <Popover className='incident-item-details-popover' onClick={(event) => event.stopPropagation()}>
      <Popover.Header className='incident-item-details-popover-header'>Andre oplysninger</Popover.Header>
      <Popover.Body className='incident-item-details-popover-body'>
        {
          actions.length > 0 &&
          <div className='entity-item-details-section'>
            <div className='entity-item-details-section-headline'>Udførte handlinger</div>
            {
              
              actions.map((actionItem:IAction, index: number) => {
                const dateTimeAreaFormatCode = currentLanguageFormatCode
                const timestampTyped = new Date(actionItem.time)
                const timestampLocal = ToLocaleStringFixed(timestampTyped, dateTimeAreaFormatCode, true)
                const actionID = 'entity-item-details-section-action' + index
                
                return (
                  <React.Fragment key={actionID}>
                    <div id={actionID} className='entity-item-details-section-content'>
                      <div className='entity-item-details-section-headline'>{timestampLocal + ' - ' + actionItem.name}</div>
                      <div className='entity-item-details-section-item'>{'Af: ' + actionItem.userPrincipalName}</div>
                      <div className='entity-item-details-section-item'>Resultat:</div>
                      <div className='entity-item-details-section-item-long-text'>{actionItem.result?.result + ' ' + actionItem.result?.message}</div>
                    </div>
                  </React.Fragment>
                )                  
              })
            }
          </div>
        }
        {
          entityIncident.incident.history &&
          <div className='entity-item-details-section'>
            <div className='entity-item-details-section-headline'>Historik</div>
            {
                entityIncident.incident.history.map((incidentHistoryItem:IIncidentHistory, index: number) => {
                  const dateTimeAreaFormatCode = currentLanguageFormatCode
                  const timestampTyped = new Date(incidentHistoryItem.timestamp)
                  const timestampLocal = ToLocaleStringFixed(timestampTyped, dateTimeAreaFormatCode, true)
                  const historyItemID = 'entity-item-details-section-history' + index.toString()
                  
                  return (
                    <React.Fragment key={historyItemID}>
                      <div id={historyItemID} className='entity-item-details-section-content'>
                        <div className='entity-item-details-section-headline'>
                          {
                            timestampLocal + ' - ' + 
                            (
                              (incidentHistoryItem.action == 'AssignedToUser') 
                              ?
                                'Ansvar tildelt'
                              :
                                (incidentHistoryItem.action == 'Cancelled') 
                                ?
                                  'Annulleret'
                                : 
                                  'Handling ikke genkendt.'
                            )
                          }
                        </div>
                        <div className='entity-item-details-section-item'>
                          {'Af: ' + incidentHistoryItem.userID}
                        </div>
                        <div className='entity-item-details-section-item'>
                          {
                            incidentHistoryItem.action == 'AssignedToUser' 
                            ?
                              'Til: ' + incidentHistoryItem.data?.userID
                            :
                              incidentHistoryItem.action == 'Cancelled' 
                              ?
                                'Årsag: ' + incidentHistoryItem.data?.reason
                              : 
                                ''
                            }
                        </div>
                        <div className='entity-item-details-section-item'>Kommentar:</div>
                        <div className='entity-item-details-section-item-long-text'>
                          {incidentHistoryItem.comment}
                        </div>
                      </div>
                    </React.Fragment>
                  )                  
              })
            }
          </div>
        }
      </Popover.Body>
    </Popover>
  )

  return (   
    <> 
      <OverlayTrigger trigger={['click']} rootClose={true} placement='auto' overlay={renderContextMenu(props.entityIncident) }>
        <div>
          Andre oplysninger...
        </div>        
      </OverlayTrigger>
    </>
  )
}

export default IncidentItemDetailsContextMenuPart
